export const ConstantStrings = {
  MIN_NAME_LENGTH: 2,
  MAX_NAME_LENGTH: 50,
  PREPOPULATE_PASSWORD_STRING:
    'Password must be 8 to 15 characters long and include at least one lowercase letter, one uppercase letter, one number, and one special character.',
};
